import { defineStore } from 'pinia';
import api from '@/api/api';

export const useLaboratoryStore = defineStore('laboratory', {
    state: () => {
        return {
            laboratories: [],
            currentLab: null,
            loading: false
        }
    },
    actions: {
        async fetchLaboratories() {
            this.loading = true;
            try {
                const { data } = await api().get('/laboratory');
                this.laboratories = data;
            } catch (error) {
                console.error("Erro ao buscar laboratórios:", error);
            } finally {
                this.loading = false;
            }
        },

        setCurrentLab(lab) {
            this.currentLab = lab;
        }
    },
    persist: [
        { pick: ['currentLab'], storage: sessionStorage }
    ]
});